export default {
  state: {
    viewId: sessionStorage.getItem('tree-viewId') ? sessionStorage.getItem('tree-viewId') : '',
    modelId: sessionStorage.getItem('tree-modelId') ? sessionStorage.getItem('tree-modelId') : '',
    projectNoType: sessionStorage.getItem('tree-projectNoType') ? sessionStorage.getItem('tree-projectNoType') : '',
    curModelId: sessionStorage.getItem('tree-cur-modelId') ? sessionStorage.getItem('tree-cur-modelId') : '',
  },
  mutations: {
    SET_VIEW_ID(state, viewId) {
      state.viewId = viewId;
      sessionStorage.setItem('tree-viewId', viewId);
    },
    SET_MODEL_ID(state, modelId) {
      state.modelId = modelId;
      sessionStorage.setItem('tree-modelId', modelId);
    },
    SET_PROJECT_ID_TYPE(state, projectNoType) {
      state.projectNoType = JSON.stringify(projectNoType);
      sessionStorage.setItem('tree-projectNoType', JSON.stringify(projectNoType));
    },
    SET_CUR_MODEL_ID(state, curModelId) {
      state.curModelId = curModelId;
      sessionStorage.setItem('tree-cur-modelId', curModelId);
    }
  },
  actions: {
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/tree.js